module.exports = __webpack_public_path__ + "static/media/front.a098bbe2.jpg";